import {
	CCT_ONLY_DEVICES,
	HALF_SLEEPING_TYPES,
	LOCAL_PATHS,
	PROFILE_DEVICES,
	SLEEPING_TYPES,
} from '../constants';
//Stores
import { home_data, user_data } from 'src/stores/account/user';
import { readDeviceStatus, readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
import { devices_settings, devices_status } from 'src/stores/device-runtime/status';
import { devices } from 'src/stores/lists/devices';
import { groups } from 'src/stores/lists/groups';
import { network, wifi_ssid } from 'src/stores/session/native-bridge';

import type { Device } from 'src/types/Device';
import { allDiscovered, local_devices } from 'src/stores/features/discovered';
import { devices_config } from '@devices/index';
/**
 * Helper functions strictly for shelly app interface.
 * Strongly coupled with the data stores and data structures
 */
import { get } from 'svelte/store';
import { validate_ip } from 'src/helpers/validators';
import { get_fresh_verified_local_ip } from 'src/stores/device-runtime/verified-local-ips';
import { devices_config_wave } from 'src/devices_config_wave';
import { requestSaveGroup } from 'src/components/Lists/list-helpers';
import { decimal_to_hex, hex_to_decimal } from './utilities';
import { getTemplateMode, isXT1ComponentDevice, isXT1Module } from './xt1_helpers/template_helpers';
import { isPeripheralDevice } from './addons/addon_device_helpers';
import { parseID } from 'src/components/DevicesSettings/Settings/SettingsG2/ThermostatsWallDisplay/helpers';
import { getXMODMode } from './xmod_helpers/xmod_config_helpers';
import {
	detectComponentsFromStatus,
	getModeFromComponents,
	applyXCSpecToStatus,
	getJWSFromDevice,
	fetchJWSFromBackend,
	hasSysChComponents,
} from './xmod_helpers/xcspec_helpers';
import { XMOD_MAX_COMPONENT_INDEX } from 'src/constants';
import { isVirtualDevice } from './virtual_helpers/virtual_components_helpers';

export function real_id(id: string): string {
	if (id) {
		// if (id.toString().startsWith('X')) {
		// return id;
		// }
		return id.toString().replace(/\_\d+/, '');
	} else {
		return '';
	}
}

export function real_id_z(id: string): string {
	return id.toString().replace(/\_\d/, '');
}

export function filter_devices_by_room(devices, room_id) {
	// return Object.values(devices).reduce((filtered,d)=>{
	//     if (d.room_id==room_id) {
	//         filtered[d.id] = d
	//     }
	//     return filtered;
	// }, {})
	let filtered = {};
	for (const k in devices) {
		if (Object.prototype.hasOwnProperty.call(devices, k) && devices[k].room_id == room_id) {
			filtered[k] = devices[k];
		}
	}
	return filtered;
}

export function sensors_in_devices_filter(devices, status) {
	let res = [];
	for (const k in devices) {
		if (Object.prototype.hasOwnProperty.call(devices, k)) {
			const d = devices[k];
			if (d?.category === 'sensor' || d?.category === 'thermostat') {
				res.push(d);
			}

			if (d?.category === 'relay') {
				if (typeof status[d.id] !== 'undefined') {
					if (
						typeof status[d.id].ext_humidity !== 'undefined' &&
						(Object.keys(status[d.id].ext_humidity).length > 0 ||
							status[d.id].ext_humidity.length > 0)
					) {
						res.push(d);
					}
					if (
						typeof status[d.id].ext_temperature !== 'undefined' &&
						(Object.keys(status[d.id].ext_temperature).length > 0 ||
							status[d.id].ext_temperature.length > 0)
					) {
						res.push(d);
					}
				}
			}
		}
	}
	// Object.values(devices).forEach(d => {

	//     if ((d?.category === "sensor")) {
	//         res.push(d)
	//     }

	//     if ((d?.category === "relay")) {
	//         if (typeof status[d.id] !== "undefined") {

	//             if (typeof status[d.id].ext_humidity !== "undefined" && (Object.keys(status[d.id].ext_humidity).length > 0 || status[d.id].ext_humidity.length > 0)) {
	//                 res.push(d)
	//             }
	//             if (typeof status[d.id].ext_temperature !== "undefined" && (Object.keys(status[d.id].ext_temperature).length > 0  || status[d.id].ext_temperature.length > 0)) {
	//                 res.push(d)
	//             }
	//         }
	//     }
	// })

	return [...new Set(res)];
}

export function tmp_units_from_settings(settings) {
	return `°${
		settings?.sensors?.temperature_unit ||
		settings?.tmp?.units ||
		settings?.thermostats?.[0]?.target_t?.units ||
		settings?.ht_ui?.temperature_unit ||
		settings?.sys?.ui_data?.temperature_unit ||
		settings?.ext_sensors?.temperature_unit ||
		'C'
	}`;
}

export const celsius_to_fahrenheit = (c: number) => {
	return Number(((c * 9) / 5 + 32).toFixed(1));
};

export const fahrenheit_to_celsius = (f: number) => {
	return Number((((f - 32) * 5) / 9).toFixed(2));
};

export const f_to_c = (f: number, toFixed: number) => {
	let [_, second] = f.toString().split('.');

	f = Number(second) >= 5 ? Math.ceil(f) : Math.floor(f);

	return Number((f / 1.8).toFixed(toFixed));
};

export const c_to_f = (c: number, toFixed: number) => {
	let [_, second] = c.toString().split('.');

	if (Number(second) >= 5) {
		c = Math.ceil(c);
	} else {
		c = Math.floor(c);
	}
	return Number((c * 1.8).toFixed(toFixed));
};

export const calculateWhenEnd = (startTime, dur) => {
	let [hours = 0, min = 0] = startTime.split(':');
	//get some day to calculate hours
	let UTC_date = Date.UTC(2021, 6, 1, Number(hours), Number(min), 0);
	let end_time = new Date(UTC_date + Number(dur) * 60 * 1000);

	let _hours = end_time.getUTCHours();
	let _min = end_time.getUTCMinutes();

	return `${Number(_hours < 10) ? `0${_hours}` : _hours}:${Number(_min) < 10 ? `0${_min}` : _min}`;
};

export function is_in_local_network(device, ssid, status) {
	// return true; //this is for returning always local ips :Dev mode
	if (typeof get(local_devices)[device.id] !== 'undefined') {
		return true;
	}
	if (is_gen_2(device)) {
		return status?.wifi?.ssid === ssid;
	} else {
		return status?.wifi_sta?.ssid === ssid;
	}
}

export function get_ip_from_status(device, status) {
	if (is_gen_2(device)) {
		return status?.eth?.ip ? status.eth.ip : status?.wifi?.sta_ip;
	} else {
		return status?.wifi_sta?.ip;
	}
}

export const get_ip = (status) => {
	return status?.eth?.ip
		? status.eth.ip
		: typeof status?.wifi_sta !== 'undefined'
			? status?.wifi_sta?.ip
			: status?.wifi?.sta_ip;
};

function ip_from_network_scan(id) {
	const ip = get(allDiscovered)[id] || get(devices)[id]?.ip;
	return validate_ip(ip) ? ip : false;
}

const can_use_local_ip = (device, networkSSID, deviceSSID, useLocal) =>
	deviceSSID === networkSSID &&
	useLocal === true &&
	!SLEEPING_TYPES.includes(device?.type) &&
	!HALF_SLEEPING_TYPES.includes(device?.type);

export function get_local_ip(id) {
	if (id === undefined || id === null || id === '') return false;

	const realId = real_id(id);
	const device = get(devices)[realId];
	if (!device) return false;

	const networkSSID = get(wifi_ssid);
	const status = devices_status.getByRealId(id);
	const settings = devices_settings.getByRealId(id);
	const deviceSSID = get_ssid(settings, status, device);
	const useLocal = get(home_data)?.globalLocalControl?.useLocal === true;

	if (!can_use_local_ip(device, networkSSID, deviceSSID, useLocal)) return false;

	const verifiedIp = get_fresh_verified_local_ip(realId);
	if (verifiedIp) return verifiedIp;

	if (status?.online) return get_ip_from_status(device, status) ?? false;
	return ip_from_network_scan(realId) || false;
}

export function get_ssid(settings, status, device) {
	return SLEEPING_TYPES.includes(device?.type) && typeof settings?.wifi_sta?.ssid !== 'undefined'
		? settings?.wifi_sta?.ssid
		: SLEEPING_TYPES.includes(device?.type) && typeof settings?.wifi?.sta?.ssid !== 'undefined'
			? settings?.wifi?.sta?.ssid
			: typeof status?.wifi_sta?.ssid !== 'undefined'
				? status?.wifi_sta?.ssid
				: status?.wifi?.ssid;
}

/**
 * Gets the device mode based on device type, status, and settings.
 *
 * XMOD NOTE:
 * - For XMOD devices, this relies on xcspec-populated `status.sys.ch` (see `processXMODStatus`
 *   and `getModeFromComponents` in `xcspec_helpers.ts`).
 * - Changing how XMOD components map to modes is a **breaking change**:
 *     - it affects which controls, settings, and group actions are shown for XMOD devices,
 *     - and must stay in sync with backend / XCSpec expectations.
 *
 * @param device - The device object
 * @param status - The device status object
 * @param settings - The device settings object
 * @returns The device mode string (e.g., 'light', 'cct', 'relay', 'inputs_reader', 'shell')
 */
export function get_mode(device, status, settings) {
	if (isVirtualDevice(device?.type)) {
		return 'virtual';
	} else if (isFanDevice(device?.type)) {
		return 'fan';
	} else if (isPeripheralDevice(device?.type)) {
		return device?.mode;
	} else if (isXT1Module(device?.type)) {
		return getTemplateMode(device);
	} else if (isWallDisplay(device?.type)) {
		// For wall display extension devices (_100 media player, _101 thermostat) use device.mode directly.
		// Because we must distinguish three Wall Display cases with different mode sources:
		// Main device (no suffix): derive mode from status.sys.ch[0] when available.
		// Secondary channel devices (1, _2, ... < 100): derive mode from status.sys.ch[channelIndex] (they mirror components like switch/light).
		// Extension devices (100 media player, _101 thermostat): do NOT derive from sys.ch; use device.mode directly.
		//isSecondaryWallDisplay only identifies channels < 100. The explicit suffix check (>= 100) catches extension devices so we don’t accidentally treat them like channels and show the wrong tabs/settings.
		const idSuffix = device?.id?.split('_')[1];
		if (idSuffix && /^\d+$/.test(idSuffix) && Number(idSuffix) >= 100) {
			return device?.mode || device?.category;
		}

		// Check if this is a channel device (deviceId_1, deviceId_2, etc.)
		const isChannelDevice = isSecondaryWallDisplay(device);

		// Only handle numeric channel indices (0, 1, 2...), not 100 or 101
		if (isChannelDevice) {
			const channelIndex = device.channel;
			// Get the component from status.sys.ch array using channel index
			if (status?.sys?.ch && Array.isArray(status.sys.ch)) {
				const component = status.sys.ch[channelIndex];
				if (component) {
					// Extract the component type (e.g., 'switch' from 'switch:0')
					const componentType = component.split(':')[0];
					if (componentType === 'light') {
						return 'light';
					} else if (componentType === 'switch') {
						return 'relay';
					}
				}
			}
		}

		// For main device without channel suffix or when status.sys.ch has multiple components
		if (
			(status?.sys?.ch && Array.isArray(status.sys.ch) && status.sys.ch.length > 0) ||
			hasSysChComponents(status)
		) {
			// Use the first component for the main device
			const firstComponent = status.sys.ch[0];
			if (firstComponent) {
				const componentType = firstComponent.split(':')[0];
				if (componentType === 'light') {
					return 'light';
				} else if (componentType === 'switch') {
					return 'relay';
				}
			}
		}

		// Fallback to existing logic if status.sys.ch is not available
		return device?.mode || device?.category;
	} else if (isRgbwwPm(device?.type)) {
		return settings?.sys?.device?.profile;
	} else if (PROFILE_DEVICES.includes(device?.type)) {
		return get_gen_2_component_from_profile(device);
	} else if (isCctOnlyDevice(device?.type)) {
		return 'cct';
	} else if (isXMODDevice(device?.type)) {
		if (device?.id?.includes('_') && device?.mode) {
			return device.mode;
		}
		if (hasSysChComponents(status)) {
			const mode = getXMODMode(status.sys.ch);
			if (mode) {
				return mode;
			}
		}
		const componentTypes = ['switch', 'light', 'cct', 'rgbw', 'input'];
		for (const compType of componentTypes) {
			for (let i = 0; i < XMOD_MAX_COMPONENT_INDEX; i++) {
				const componentKey = `${compType}:${i}`;
				if (status?.[componentKey] && typeof status[componentKey] === 'object') {
					const detectedComponents = [componentKey];
					const mode = getXMODMode(detectedComponents);
					if (mode) {
						return mode;
					}
				}
			}
		}
		return device.mode || settings?.sys?.device?.profile || 'shell';
	} else if (device?.category === 'module') {
		return device.mode;
	} else {
		if (is_gen_z(device)) {
			return devices_config_wave[device?.type].family;
		} else if (isProThreeEM(device?.type)) {
			return settings?.sys?.device?.profile || settings?.DeviceInfo?.profile || 'triphase';
		} else if (isCover(device?.type)) {
			if (isShutter(device.type) || isProCover(device.type)) {
				return 'roller';
			} else if (settings?.sys?.device?.profile == 'cover') {
				return 'roller';
			} else {
				//preventing returning of 'switch' as mode. Used for https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2057
				return 'relay';
			}
		} else if (typeof status?.mode !== 'undefined') {
			return status.mode;
		} else if (
			typeof status?.[device?.category?.split('s_')?.[0] + 's']?.[device?.channel]?.mode !==
			'undefined'
		) {
			return status[device?.category.split('s_')[0] + 's'][device.channel].mode;
		} else if (typeof settings?.mode !== 'undefined' && settings.mode !== '_unknown_') {
			return settings.mode;
		} else if (
			devices_config?.[device?.type]?.family === 'light' &&
			(!is_gen_2(device) || device?.type === 'SNDM-0013US')
		) {
			return 'white';
		} else if (devices_config?.[device?.type]?.family === 'light' && isRgbCct(device?.type)) {
			// For rgbcct devices, read the actual mode from status
			const componentPath = get_status_settings_component_path(device);
			if (status?.[componentPath]?.mode) {
				return status[componentPath].mode; // returns 'rgb' or 'cct'
			}
			return 'rgbcct'; // fallback
		} else if (devices_config?.[device?.type]?.family) {
			return devices_config[device?.type].family;
		} else {
			return 'relay';
		}
	}
}

export function input_settings_check(settings, device) {
	if (is_gen_2(device)) {
		return settings[`switch:${device.channel}`]?.in_mode !== 'momentary';
	} else {
		if (
			typeof settings?.[device?.category.split('s_')[0] + 's'][device.channel].btn_type !==
			'undefined'
		) {
			return (
				settings[device?.category.split('s_')[0] + 's'][device.channel].btn_type.indexOf(
					'momentary',
				) === -1
			);
		} else if (
			typeof settings?.[device?.category.split('s_')[0] + 's'][0].btn1_type !== 'undefined' &&
			typeof settings?.[device?.category.split('s_')[0] + 's'][0].btn2_type !== 'undefined'
		) {
			//this is for shsw-1L
			return (
				settings?.[device?.category.split('s_')[0] + 's'][0].btn1_type.indexOf('momentary') ===
					-1 &&
				settings?.[device?.category.split('s_')[0] + 's'][0].btn2_type.indexOf('momentary') ===
					-1
			);
		} else if (
			typeof settings?.[device?.category.split('s_')[0] + 's'][0].btn_type !== 'undefined'
		) {
			//this is for rgbw2 because btn type is only in its 1st channel
			return (
				settings?.[device?.category.split('s_')[0] + 's'][0].btn_type.indexOf('momentary') === -1
			);
		}
	}
}

/**
 * Pro RGBWW PM: Function to get the supported input ids based on the control component
 * @param device
 * @returns array of supported input ids
 */
const getSupportedInputIds = (device: Device): number[] => {
	if (typeof device === 'undefined') return [];
	const component = get_gen_2_component_channel_structure(device);

	const profile = devices_settings.getByRealId(device.id)?.sys?.device?.profile || '';
	switch (profile) {
		case 'rgbcct':
			if (component === 'rgb:0') return [0, 1];
			else if (component === 'cct:0') return [2, 3];
			break;
		case 'rgbx2light':
			if (component === 'rgb:0') return [0];
			else if (component.startsWith('light:')) {
				return [device.channel + 1];
			}
			break;
		case 'cctx2':
			if (component === 'cct:0') return [0, 1];
			else if (component === 'cct:1') return [2, 3];
			break;
		case 'light':
		default:
			return [device.channel];
	}

	return [];
};

export function input_status_check(status, device) {
	const index = get_device_component_index(device);

	if (typeof status.inputs !== 'undefined' && status.inputs.length > 0) {
		return status?.inputs[index]?.input === 1;
	} else if (isRgbwwPm(device.type)) {
		let inputs = getSupportedInputIds(device);
		return inputs.some(
			(input) => typeof status[`input:${input}`] !== 'undefined' && status[`input:${input}`].state,
		);
	} else if (is_gen_2(device) && typeof status[`input:${index}`] !== 'undefined') {
		return status[`input:${index}`].state;
	}
}

export function is_local_image(image) {
	return LOCAL_PATHS.find((_uri) => image?.includes(_uri));
}

//subscribe to get user data and make a URL
export function load_image_from(image, deviceUrl?) {
	if (/^(https?:\/\/)/.test(image)) return image;
	let url =
		typeof deviceUrl !== 'string' || deviceUrl.length === 0
			? get(user_data).user_api_url
			: deviceUrl;
	if (!url.startsWith('https://')) url = 'https://' + url;

	return is_local_image(image) ? image : url + '/shelly_files/' + image;
}

// export function shelly_id_16(num: number, pad: number = 6): string {
// 	let str_id = num.toString(16);
// 	if (str_id.length > 6 && pad == 6) pad = 12;
// 	while (str_id.length < pad) {
// 		str_id = '0' + str_id;
// 	}
// 	return str_id;
// }

/**
 * Generate Shelly ID in hex pre-padding to 6 characters.
 * - Non-numerical ids will be returned untouched!
 */
export function shellyId16(id: string, pad: number = 6): string {
	if (id[0] == 'X' || id == '') return id;

	const num = Number(id);
	if (isNaN(num)) return id;

	var strToParse = num.toString(16);
	if (strToParse.length > 6 && pad == 6) pad = 12;

	while (strToParse.length < pad) {
		strToParse = '0' + strToParse;
	}

	return strToParse;
}

/**
 * Helper to get the component index bassed on input id
 * @param deviceId
 * @param inputId
 * @returns component index
 */
const getComponentIndexByInput = (deviceId, inputId) => {
	switch (devices_settings.getByRealId(deviceId)?.sys?.device?.profile) {
		case 'rgbx2light':
			return inputId == 2 || inputId == 3 ? inputId - 1 : 0;
		case 'rgbcct':
		case 'cctx2':
			return inputId == 2 || inputId == 3 ? 1 : 0;
		case 'light':
		default:
			return inputId - 1;
	}
};

/**scenes specific cases conditions and actions sdr => ui getting hex id
 * - conditions based on channel+1 indexes in scene service (sdr notation)
 * 		including SHEM-3 m1, m2, m3
 * 		including SHDM-1 and SHDM-2 input state and button state 1/2, but one real outpur ie1, ie2, i1, i2
 * 		including the same input case two inputs for SHSW-L, S3SW-0A1X1EUL, S4SW-0A1X1EUL but one output
 * 		for future - Pro EM (when have own channels) will need new logic for split & 0 channels
 * 		all other conditions just check if the channel is 0, to skip it in ID concatenation
 * - actions
 * 	just check if the channel is 0 to skip it in id
 */
export const createDeviceID = (id, channel, type) => {
	//Virtual devices have device_id, based on the virtual group channel. The logic after is not viable for them
	if (channel >= 200) {
		return `${id}_${channel}`;
	}

	if (['SPDC-0D5PE16EU'].includes(type)) {
		const channelIndex = getComponentIndexByInput(id, channel + 1);
		return channelIndex > 0 ? `${id}_${channelIndex}` : id;
	}

	const mode = get(devices)[id]?.mode;
	if (
		(['SNDC-0D4P10WW'].includes(type) && ['rgbw', 'rgb'].includes(mode)) ||
		[
			'SHEM-3',
			'SHDM-1',
			'SHDM-2',
			'SHSW-L',
			'S3SW-0A1X1EUL',
			'S4SW-0A1X1EUL',
			'S3SW-0A1X5US',
		].includes(type) ||
		channel === 0 ||
		([
			'SPEM-003CEBEU',
			'SPEM-003CEBEU400',
			'SPEM-003REBEU2000',
			'SPEM-003CEBEU63',
			'EFPEM-003CEBEU120',
			'S3EM-003CXCEU63',
			'S4EM-003RXCEU63',
		].includes(type) &&
			mode === 'triphase')
	) {
		return id;
	}
	if (isBluRC(type)) {
		//this is a remote controller with two inputs(left and right btns)
		return id;
	}

	if (channel > 0) {
		return `${id}_${channel}`;
	}

	return id;
};

export function check_and_repair_hex_id_lenght(_id: string | number): string {
	let id = typeof _id === 'string' ? _id : _id.toString();

	if (id.length % 2 === 0) {
		return id;
	}

	return `0${id}`;
}

export function getIsCalibrationFromstatus(device, status): boolean {
	return (
		// for gen 1 dimmers we check the parameter: 'calib_running'
		status?.calib_running === 1 ||
		// for gen 1 rollers we check the parameter: 'calibrating' in rollers[0]
		status?.rollers?.[0]?.calibrating ||
		// for gen 2 roller (covers) we check the parameter 'state' === 'calibrating' in Cover component
		status?.[`cover:${device.channel}`]?.state === 'calibrating'
	);
}

export function getIsDimmerCalibratingFromStatus(device, status): boolean {
	return typeof status?.[`light:${device.channel}`]?.calibration !== 'undefined';
}

export function get_gen_1_path_from_category(device): string {
	return device?.category?.split('s_')[0] + 's';
}

/**
 * Helper to get the control component
 * The difference with @function get_gen_2_component_from_category is that it returns the control component,
 * i.e for emeter devices it returns the switch component.
 * For XMOD devices, determines component from status.sys.ch (xcspec) or falls back to device mode.
 * @param device - The device object
 * @returns control component string (e.g., 'switch', 'light', 'cct', 'input')
 */
export function get_gen_2_control_component_from_category(device): string {
	if (device?.category === 'emeter') {
		return 'switch';
	}
	if (isXMODDevice(device?.type)) {
		const realId = real_id(device.id);
		let status = devices_status.getByRealId(realId) || devices_status.getByRealId(device.id);

		const channelIndex = device?.channel || 0;
		const modeToComponentMap: Record<string, string> = {
			light: 'light',
			rgbw: 'rgbw',
			cct: 'cct',
			relay: 'switch',
			inputs_reader: 'input',
		};

		if (hasSysChComponents(status)) {
			const component = status.sys.ch[channelIndex] || status.sys.ch[0];
			if (component) {
				const componentType = component.split(':')[0];
				return componentType;
			}
		}

		if (status) {
			const componentTypes = ['light', 'cct', 'switch', 'rgbw', 'input'];
			for (const compType of componentTypes) {
				const componentKey = `${compType}:${channelIndex}`;
				if (status[componentKey] && typeof status[componentKey] === 'object') {
					return compType;
				}
			}

			for (const key of Object.keys(status)) {
				if (/^(light|cct|switch|rgbw|input):\d+$/.test(key) && typeof status[key] === 'object') {
					const componentType = key.split(':')[0];
					return componentType === 'rgbw' ? 'light' : componentType;
				}
			}
		}

		if (device?.mode && device.mode !== 'shell') {
			return modeToComponentMap[device.mode] || 'light';
		}

		return 'light';
	}
	return get_gen_2_component_from_category(device);
}

/**
 * Gets the Gen2 component type from device category or type
 * For XMOD devices, determines component from status.sys.ch (xcspec) or falls back to device mode.
 *
 * XMOD NOTE:
 * - This is the central place where XMOD components are translated into Gen2 component names
 *   (e.g. which `.SetConfig` / `.set` RPC is used).
 * - Adjusting the XMOD branch here is a **breaking change** for:
 *     - RPC method names used by controls and settings,
 *     - group control helpers that build XMOD requests.
 * @param device - The device object
 * @returns component type string (e.g., 'switch', 'light', 'cct', 'rgbw', 'input')
 */
export function get_gen_2_component_from_category(device) {
	if (isXT1ComponentDevice(device)) {
		return device.component.split(':')[0];
	}
	if (isXMODDevice(device?.type)) {
		const realId = real_id(device.id);
		let status = devices_status.getByRealId(realId);
		if (!status) {
			status = devices_status.getByRealId(device.id);
		}

		if (hasSysChComponents(status)) {
			const channelIndex = device?.channel || 0;
			const component = status.sys.ch[channelIndex] || status.sys.ch[0];
			if (component) {
				const componentType = component.split(':')[0];
				return componentType;
			}
		}

		if (device?.mode) {
			if (device.mode === 'light') return 'light';
			if (device.mode === 'rgbw') return 'rgbw';
			if (device.mode === 'cct') return 'cct';
			if (device.mode === 'relay') return 'switch';
			if (device.mode === 'inputs_reader') return 'input';
		}

		return 'shell'; // Safe default for XMOD when no concrete component is detected
	}

	if (isFanDevice(device?.type)) {
		return 'fan';
	}

	let component = 'switch';
	if (PROFILE_DEVICES.includes(device?.type)) {
		component = get_gen_2_component_from_profile(device);
	} else if (isNoRelayPlug(device?.type)) {
		return 'pm1';
	} else {
		// Check device type first for special CCT devices
		if (isCctOnlyDevice(device?.type)) {
			return 'cct'; //new component for S3BL, Hilux, and X Module
		}

		switch (device?.category) {
			case 'light':
				component = 'light';
				if (isRgbCct(device?.type)) {
					component = 'rgbcct';
				}
				break;
			case 'inputs_reader':
				component = 'input';
				break;
			case 'roller':
				component = 'cover';
				break;
			case 'ext_sensor':
				component = 'temperature';
				break;
			case 'emeter':
				component = 'em';
				if (
					isGen2EM(device?.type) ||
					(isProThreeEM(device?.type) && device.mode === 'monophase')
				) {
					component = 'em1';
				}
				break;
			case 'power_meter':
				component = 'pm1';
				break;
			case 'module':
				switch (device.mode) {
					case 'inputs_reader':
						component = 'input';
						break;
					default:
						component = 'switch';
						break;
				}
				break;
			case 'breaker':
				component = 'cb';
				break;
			case 'diffuser':
				component = 'cury';
				break;
			default:
				component = 'switch';
				break;
		}
	}
	return component;
}

export function get_z_wave_component_from_category(device) {
	//ToDo finish this function must return structure from z wave's status
	// update_z_wave_device_gen(device);
	const structure = {
		'QNSW-001X16': 'Binary Switch:', //1
		'QNSW-001P16': 'Binary Switch:', //1pm
		'QNSW-002P16': 'Binary Switch:', //2pm
		'QNSH-001P10': 'Multilevel Switch:', //shutter
		'QNSN-0A24X': 'Multilevel Switch:', //i4
		'QNSN-0D24X': 'Multilevel Switch:', //i4 dc
		'QNPL-001X16': 'Binary Switch:', //plug us
		'QNPL-001X12': 'Binary Switch:', //plug uk
		'QPSW-0A1X16': 'Binary Switch:', //pro 1
		'QPSW-0A2X16': 'Binary Switch:', //pro 2
		'QPSW-0A1P16': 'Binary Switch:', //pro 1 pm
		'QPSW-0A2P16': 'Binary Switch:', //pro 2 pm
	};
	return structure[device?.type];
}
export function get_z_wave_channel_structure_from_category(device) {
	//ToDo finish this function must return structure from z wave's status
	// update_z_wave_device_gen(device);
	const additionToDeviceChannel = {
		//the idea here is that z brothers count from 1 on multi channeled devices
		'QNSW-001X16': 0,
		'QNSW-001P16': 0,
		'QNSW-002P16': 1,
		'QNSH-001P10': 1,
		'QNSN-0A24X': 0,
		'QNSN-0D24X': 0,
		'QNPL-001X16': 0,
		'QNPL-001X12': 0,
		'QPSW-0A1X16': 0,
		'QPSW-0A2X16': 1,
		'QPSW-0A1P16': 0,
		'QPSW-0A2P16': 1,
	};
	return (
		get_z_wave_component_from_category(device) +
		(device.channel + additionToDeviceChannel[device?.type])
	);
}

export function get_gen_2_component_channel_structure(device) {
	return `${get_gen_2_component_from_category(device)}:${get_device_component_index(device)}`;
}

/**
 * Helper to get the control component structure based on the device category
 * The difference with @function get_gen_2_component_channel_structure is that it returns the control component,
 * i.e for emeter devices it returns the switch component.
 * @param device
 * @returns control component structure
 */
export function get_gen_2_control_component_channel_structure(device) {
	if (device?.category === 'emeter') {
		return 'switch:0';
	}

	return `${get_gen_2_component_from_category(device)}:${get_device_component_index(device)}`;
}

export function get_status_settings_component_path(device) {
	if (is_gen_2(device)) {
		return get_gen_2_component_channel_structure(device);
	} else {
		return get_gen_1_path_from_category(device);
	}
}

/** True when the component path targets an `LEDStrip.Set`-driven component. */
export const isLedStripComponent = (component: string | undefined): boolean =>
	!!component && /^ledstrip:\d+$/.test(component);

/** First `ledstrip:N` component key present in the device status, or undefined. */
export const getLedStripComponent = (status: any): string | undefined => {
	if (!status || typeof status !== 'object') return undefined;
	return Object.keys(status).find(isLedStripComponent);
};

/** First `serial:N` component key present in the device status, or undefined. */
export const getSerialComponent = (status: any): string | undefined => {
	if (!status || typeof status !== 'object') return undefined;
	return Object.keys(status).find((key) => /^serial:\d+$/.test(key));
};

/**
 * Function to get the index of the component in the device channel
 *
 * Usually the index is the channel number (like light:1 component for channel 1),
 * but for some devices such as Pro RGBWW PM, the index does not match the channel number.
 * For XMOD devices, gets the component index from status.sys.ch (xcspec).
 * @param device - The device object
 * @returns index of the component for the device channel
 */
export function get_device_component_index(device) {
	if (isRgbwwPm(device?.type)) {
		const status = devices_status.getByRealId(device.id);
		return status?.sys?.ch?.[device.channel]?.split(':')[1] || device.channel;
	} else if (isXT1ComponentDevice(device)) {
		return Number(device.component.split(':')?.[1]) ?? 0;
	} else if (isXMODDevice(device?.type)) {
		const status = devices_status.getByRealId(device.id);
		if (hasSysChComponents(status)) {
			const component = status.sys.ch[device?.channel || 0] || status.sys.ch[0];
			if (component) {
				const componentIndex = component.split(':')[1];
				if (componentIndex !== undefined) {
					return Number(componentIndex);
				}
			}
		}
		return device?.channel || 0;
	} else {
		return device?.channel || 0;
	}
}

// checking for Gen 1 devices
export function is_gen_1(device) {
	if (!device) return false;
	return Number(device?.gen) === 1;
}

// isGen2 is checking for gen 2 and above
export function is_gen_2(device) {
	if (!device) return false;
	return Number(device.gen) >= 2;
}

/**
 * True for Shelly **hardware generation 2** devices in the light family (e.g. Plus Wall Dimmer US,
 * Pro Dimmer PM, Plus RGBW PM, Pro RGBWW PM). Uses numeric `gen === 2`, unlike {@link is_gen_2}
 * which matches gen 2 and above.
 */
export const isGen2LightDevice = (device: Pick<Device, 'type' | 'gen'> | null | undefined): boolean => {
	if (!device?.type) return false;
	return is_gen_2(device) && devices_config[device.type]?.family === 'light';
};

export function is_gen_z(device) {
	if (!device) return false;
	return device.gen === 'GZ';
}
/**covering the uppercase type S3PB-0A15194101 also */
export const isYihao = (type: string): boolean => type === 'S3PB-0A15194101';

export function is_dali(device) {
	//gen 3 dali devices
	if (!device) return false;
	if (typeof devices_settings.getByRealId(device.id) === 'undefined') return false;
	return Object.keys(devices_settings.getByRealId(device.id)).includes('dali');
}

export const isSupportVC = (device: Device): boolean => {
	return /^(S3SW-001P8EU|S3SW-001X8EU|S3PM-001PCEU16|S3SW-001X16EU|S3SW-001P16EU|S3SN-0024X|S3SN-0D24X|S3SW-001P16SP)$/.test(
		device?.type,
	);
};

export function is_loqed(device) {
	if (!device) return false;
	return device.gen === 'GXL';
}

export function is_GBLE(device) {
	if (!device) return false;
	return device.gen === 'GBLE';
}

/**
 * Checks if device is an energy meter (EM) device.
 * Includes both Gen1 and Gen2 EM devices.
 *
 * @param deviceType - The device type/model identifier
 * @returns True if device is an EM device
 */
export function isEM(deviceType: string) {
	return /^(SHEM|SPEM-002CEBEU50|S3EM-002CXCEU|S4EM-002CXCEU|S4EM-001PXCEU16|S4EM-001CXCEU63|S4PB-06A7000101)$/.test(
		deviceType || '',
	);
}

/**
 * Checks if device is a 3-phase energy meter (3EM) device.
 *
 * @param deviceType - The device type/model identifier
 * @returns True if device is a 3EM device
 */
export function isThreeEM(deviceType: string) {
	return /^(SHEM-3|SPEM-003CEBEU|SPEM-003CEBEU400|SPEM-003REBEU2000|SPEM-003CEBEU63|S3EM-003CXCEU63|S4EM-003RXCEU63|EFPEM-003CEBEU120)$/.test(
		deviceType || '',
	);
}

/**
 * Checks if device is a Pro 3-phase energy meter (Pro 3EM) device.
 * Specific to Gen2+ emeters.
 *
 * @param deviceType - The device type/model identifier
 * @returns True if device is a Pro 3EM device
 */
export function isProThreeEM(deviceType: string) {
	return /^(SPEM-003CEBEU|SPEM-003CEBEU400|SPEM-003REBEU2000|SPEM-003CEBEU63|S3EM-003CXCEU63|S4EM-003RXCEU63|EFPEM-003CEBEU120)$/.test(
		deviceType || '',
	);
}

/**
 * Checks if device is a Gen2+ energy meter device.
 *
 * @param deviceType - The device type/model identifier
 * @returns True if device is a Gen2 EM device
 */
export function isGen2EM(deviceType: string) {
	return /^(SPEM-002CEBEU50|S3EM-002CXCEU|S4EM-002CXCEU|S4EM-001PXCEU16|S4EM-001CXCEU63|S4PB-06A7000101)$/.test(
		deviceType || '',
	);
}

/**
 * Check if emeter device has switch control
 * @param device
 */
export function isEmeterWithRelay(device: Device) {
	const device_id = real_id(device.id);
	const settings = readDeviceSettings(device_id);
	if (!settings) {
		return false;
	}
	if (device?.category !== 'emeter' || device?.mode !== 'emeter') {
		return false;
	}
	if (device.id.includes('_') && device?.channel !== 0) {
		return false;
	}

	return Object.keys(settings).some((key) => key.startsWith('switch') || key.startsWith('relay'));
}

/**
 * Checks if device is an energy meter without switch/relay output.
 * These are meter-only devices that can only monitor power consumption.
 *
 * @param deviceType - The device type/model identifier
 * @returns True if device is an EM device without switch
 */
export function isEMWithoutSwitch(deviceType: string) {
	return /^(S4EM-001PXCEU16|S4EM-001CXCEU63|S4PB-06A7000101)$/.test(deviceType || '');
}

/**
 * Checks if device is a Shelly Daisy EM energy meter.
 * DaisyEM has unique firmware behaviors: active tariff rate in EM1.GetStatus,
 * TOU tariff table configuration, and dedicated DaisyEM.GetStatus error/flag reporting.
 *
 * @param deviceType - The device type/model identifier
 * @returns True if device is a Daisy EM
 */
export function isDaisyEM(deviceType: string) {
	return deviceType === 'S4PB-06A7000101';
}

/**
 * Checks if device is any Pro energy meter device.
 *
 * @param deviceType - The device type/model identifier
 * @returns True if device is a Pro EM device
 */
export function isProAnyEM(deviceType: string) {
	return /^(SPEM-002CEBEU50|SPEM-003CEBEU|SPEM-003CEBEU400|SPEM-003REBEU2000|SPEM-003CEBEU63|S3EM-002CXCEU|S4EM-002CXCEU|S3EM-003CXCEU63|S4EM-003RXCEU63|S4EM-001CXCEU63|EFPEM-003CEBEU120)$/.test(
		deviceType || '',
	);
}

export function isCover(deviceType: string) {
	return /^(SPSW-002PE16EU|SPSW-102PE16EU|SPSW-202PE16EU|SPSW-202PE12UL|SNSW-002P16EU|SNSW-102P16EU|S4SW-002P16EU|S3SH-0A2P4EU|SPSH-102PE16EU|SPSH-002PE16EU|S3SW-002P16EU)$/.test(
		deviceType || '',
	);
}

export function isCctOnlyDevice(deviceType: string | undefined) {
	const cctOnlyPattern = `^(${CCT_ONLY_DEVICES.join('|')})$`;
	return new RegExp(cctOnlyPattern).test(deviceType || '');
}

export function isCoverWithDeviceProfile(deviceType: string) {
	return /^(SPSW-002PE16EU|SPSW-102PE16EU|SPSW-202PE16EU|SPSW-202PE12UL|SNSW-002P16EU|SNSW-102P16EU|S4SW-002P16EU|S3SW-002P16EU)$/.test(
		deviceType || '',
	);
}

export function lightDevicesWithoutModeSwitch(deviceType: string) {
	const cctOnlyPattern = CCT_ONLY_DEVICES.join('|');
	const otherDevices = 'SHRGBW2|SHBDUO-1|SNDC-0D4P10WW|SNDM-00100WW|SPDC-0D5PE16EU';
	const pattern = `^(${otherDevices}|${cctOnlyPattern})$`;
	return new RegExp(pattern).test(deviceType || '');
}

export function isDimmerWithTransitionMinLimitations(deviceType: string) {
	return /^S4DM-0A102US/.test(deviceType);
}

export function isProDeviceFromGen2(device) {
	return (
		is_gen_2(device) &&
		/^(SPSW-001PE40EU|SPSW-001PE16EU|SPSW-101PE16EU|SPSW-201PE16EU|SPSW-201PE15UL|SPSW-001XE16EU|SPSW-101XE16EU|SPSW-201XE16EU|SPSW-201XE15UL|SPSW-002PE16EU|SPSW-102PE16EU|SPSW-202PE16EU|SPSW-202PE12UL|SPSW-002XE16EU|SPSW-102XE16EU|SPSW-202XE16EU|SPSW-202XE12UL|SPSH-002PE16EU|SPSH-102PE16EU|SPSW-003XE16EU|SPEM-003CEBEU|SPEM-003CEBEU400|SPEM-003REBEU2000|SPEM-003CEBEU63|S3EM-003CXCEU63|S4EM-003RXCEU63|S4EM-001CXCEU63|SPSW-004PE16EU|SPSW-104PE16EU|SPDM-001PE01EU|SPDM-002PE01EU|SPEM-002CEBEU50|EFPEM-003CEBEU120)$/.test(
			device?.type || '',
		)
	);
}

export function isWeatherStation(deviceType: string) {
	return /^(SBWS-90CM)$/.test(deviceType);
}

export function isPlusUni(deviceType: string) {
	return /^(SNSN-0043X)$/.test(deviceType);
}

export function isPill(deviceType: string) {
	return /^(S3SN-0U53X)$/.test(deviceType);
}

export const isSmokeLTE = (deviceType: string): boolean => {
	return /^(SMSN-0031ZL)$/.test(deviceType);
};

export function isCamera(deviceType: string) {
	return devices_config?.[deviceType]?.family === 'camera';
}

export function isCameraDevice(device) {
	return isCamera(device?.type);
}

export const isVentoraDevice = (deviceType: string) => {
	return /^S4PB-0916176901$/.test(deviceType || '');
};

/**
 * Fan-family UI routing. Today only Ventora matches; extend independently from isVentoraDevice when more fans ship.
 */
export const isFanDevice = (deviceType: string) => isVentoraDevice(deviceType);

// Get Plug UI component for gen2+ Plugs
export function getSettingUiComponent(device) {
	//Default: `plugs_ui` if available
	if (devices_settings.getByRealId(device.id)?.plugs_ui) {
		return `plugs_ui`;
	}
	//For Power strip G4 / 'S4PL-00416EU'
	if (devices_settings.getByRealId(device.id)?.powerstrip_ui) {
		return `powerstrip_ui`;
	}

	//For Plug PM Gen3 / 'S3PL-30116EU'
	if (devices_settings.getByRealId(device.id)?.plugpm_ui) {
		return `plugpm_ui`;
	}

	// Determine the plug UI component based on the device type's friendly name
	// Suitable for Gen2 Plugs
	const plugName = devices_config[device?.type].friendly_name.split(' ');

	// plug<last word>_ui , e.g. pluguk_ui, plugs_ui
	return `plug${plugName[plugName.length - 1].toLowerCase()}_ui`;
}

export function get_gen_2_component_from_profile(device) {
	if (isRgbwwPm(device.type)) {
		return device.mode;
	} else {
		return (
			devices_settings.getByRealId(device.id)?.sys?.device?.profile ||
			devices_config[device?.type]?.family
		); //using config on initial inclusion
	}
	//changing settings?.DeviceInfo?.profile to settings?.sys?.device?.profile because in settings there is no DeviceInfo. THis is valid also for cloud disabled devices
}
export function isWallDisplay(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^SAWD/.test(deviceType || '');
}

/**
 * Checks if a device type is an XMOD device
 * @param deviceType - The device type string to check
 * @returns true if the device type matches S3MX-0A, false otherwise
 */
export function isXMODDevice(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^S3MX-0A$/.test(deviceType || '');
}

/**
 * Process XMOD device status with xcspec.
 *
 * - Applies component specification from JWS token to device status.
 * - For XMOD devices, components are determined dynamically from xcspec (component specification)
 *   stored in JWS tokens. This function detects components from status if xcspec is not yet applied,
 *   or applies xcspec from JWS token if available.
 * - This should be called whenever device status is updated for XMOD devices so that:
 *     - `status.sys.ch` is in sync with XCSpec,
 *     - downstream helpers (`getModeFromComponents`, `get_gen_2_component_from_category`, `get_mode`)
 *       see a consistent view of XMOD components.
 *
 * If the way we populate `status.sys.ch` for XMOD changes, it is a **breaking change** and must be
 * coordinated with both XCSpec and backend expectations.
 *
 * @param device - The XMOD device object
 * @param status - The device status object to process
 * @returns The processed status object with xcspec applied (status.sys.ch populated)
 */
export async function processXMODStatus(device: Device, status: any): Promise<any> {
	if (
		!isXMODDevice(device?.type) ||
		!status ||
		(status.sys.ch && Array.isArray(status.sys.ch) && status.sys.ch.length > 0)
	) {
		return status;
	}

	if (!status.sys) {
		status.sys = {};
	}

	try {
		const detectedComponents = detectComponentsFromStatus(status);
		if (detectedComponents.length > 0 && (!status.sys.ch || status.sys.ch.length === 0)) {
			if (!status.sys.ch) {
				status.sys.ch = detectedComponents;
			}
			const detectedMode = getModeFromComponents(detectedComponents);
			if (detectedMode) {
				if (!device.mode || device.mode === 'shell' || detectedMode !== device.mode) {
					device.mode = detectedMode;
					devices.update(device);
				}
			}
			return status;
		}

		const settings = devices_settings.getByRealId(device.id);

		let jws = getJWSFromDevice(device, undefined, settings);

		if (!jws && device.jti) {
			jws = await fetchJWSFromBackend(device.jti);
		}

		if (jws) {
			applyXCSpecToStatus(jws, status);

			if (status.sys?.ch && Array.isArray(status.sys.ch) && status.sys.ch.length > 0) {
				const detectedMode = getModeFromComponents(status.sys.ch);
				if (detectedMode) {
					if (!device.mode || device.mode === 'shell' || detectedMode !== device.mode) {
						device.mode = detectedMode;
						devices.update(device);
					}
				}
			}
		}
	} catch (error) {
		console.error('[xcspec] Error processing XMOD status:', error);
	}

	return status;
}

//Secondary wall display is a wall display that has a channel number less than 100> They are usually relays or lights
export function isSecondaryWallDisplay(device: Device) {
	return (
		isWallDisplay(device.type) && device?.id?.includes('_') && Number(device.id.split('_')[1]) < 100
	);
}

//check if device is actuator for wall display's thermostat
export function isActuator(settings: any, device: Device) {
	return (
		settings?.['thermostat:0'] !== undefined &&
		parseID(settings?.['thermostat:0']?.actuator) === device.id //not using real_id because now we are supporting devices with multiple channels
	);
}

export function isShutter(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	// helper function to check if device is shelly shutter
	return /^(S3SH-0A2P4EU|)$/.test(deviceType || '');
}
export function isProCover(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	// helper function to check if device is shelly pro cover
	return /^(SPSH-002PE16EU|SPSH-102PE16EU)$/.test(deviceType || '');
}

export function isShellyPresence(deviceType: string) {
	//this is used inside RoomListHolder to visualize Wall display as main sensor option
	return /^(S4SN-0U61X|S4SN-0A61X)$/.test(deviceType || '');
}

/**
 * Alarm `if` conditions use rr: `dev:<decimal>:<component>`.
 * `component` may contain colons (e.g. `presencezone:201`).
 */
export function parseAlarmDeviceRr(
	rr: string | undefined,
): { decimal: string; component: string } | null {
	if (!rr || !rr.startsWith('dev:')) return null;
	const rest = rr.slice(4);
	const i = rest.indexOf(':');
	if (i === -1) return null;
	return { decimal: rest.slice(0, i), component: rest.slice(i + 1) };
}
export function isTRV(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	//used to define BluTRV devices because this device is represented as gen 3 device but it is a blu device
	return /^SHTRV-01/.test(deviceType || '');
}
export function isMotion(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(SHMOS-01|SHMOS-02|SBMO-003Z|SBMO-103Z|SHSEN-1|S4SN-0U61X|S4SN-0A61X)$/.test(
		deviceType || '',
	);
}
export function isMotion2Gen1(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(SHMOS-02)$/.test(deviceType || '');
}
export function isTemperatureHumidity(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(SHHT-1|SHTC-1|S3SN-0013A|SBHT-002C|SBWT-002C|SNSN-0013A|S3SN-0U12A|SBHT-003C|SBHT-203C)$/.test(
		deviceType || '',
	);
}

export function isDistance(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(SBDI-003E)$/.test(deviceType || '');
}

export function isFlood(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(SHWT-1|SBWD-1|SBFL-1|SHFL-1|S4SN-0071A|S4SN-0071Z)$/.test(deviceType || '');
}

export function isDoorWindow(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(SHDW-1|SHDW-2|SBDW-002C|SBDW-002D|SBDW-103C|SBDW-203C|SBDW-302C)$/.test(deviceType || '');
}

export function isSmoke(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(SHGS-1|SNSN-0031Z|S4SN-0031Z|S3SN-0082A)$/.test(deviceType || '');
}

export function isBreaker(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^SPCB-/.test(deviceType || '');
}

export function isZendure(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return (
		/^(XPZ-SOLARFLOW|XPZ-SOLARFLOW1200|XPZ-SOLARFLOW2000|XPZ-ACE1500|XPZ-AIO2400|XPZ-HYPER2000|XPZ-HUB1200)$/.test(
			deviceType || '',
		) || deviceType.startsWith('XPZ')
	);
}

export function isBlueInput(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(SBRC-005B|SBRK-002C|SBBT-002C|SBBT-102C|SBBT-004C|SBBT-004CUS|SBBT-004CEU)$/.test(
		deviceType || '',
	);
}

export function isBluRC(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^SBRC-005B/.test(deviceType || '');
}

export function isBluRotaryKnob(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^SBRK-002C/.test(deviceType || '');
}

export function isDiffuser(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(S4PB-00CU000002)$/.test(deviceType || '');
}
export function isNoRelayPlug(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(S3PL-30116EU|S4PL-00116EU)$/.test(deviceType || '');
}

export function isNonRechargeableBattery(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(S4SN-0071A|S4SN-0071Z)$/.test(deviceType || '');
}

export function isBluTRV(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	//used to define BluTRV devices because this device is represented as gen 3 device but it is a blu device
	return /^SBTR-001AEU/.test(deviceType || '');
}

export function isGatewayG3(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(S3GW-1DBT001)$/.test(deviceType || '');
}

/**
 * Checks if a BluTRV device should be excluded from update/change operations.
 * BluTRV devices are BLE devices, not actual gen 3 devices, so they should be hidden
 * from batch firmware update and WiFi batch change operations.
 *
 * @param updateType - The type of update operation ('update', 'change', etc.)
 * @param deviceType - The device type/model identifier
 * @returns True if the device should be excluded from update/change operations
 */
export function shouldExcludeBluTRVFromUpdate(updateType: string, deviceType: string): boolean {
	return ['update', 'change'].includes(updateType) && isBluTRV(deviceType);
}

export function isRgbCct(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(S3BL-C010007AEU)$/.test(deviceType || '');
}

export function isPlusRgbwPm(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return deviceType === 'SNDC-0D4P10WW';
}

export function isRgbwwPm(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(SPDC-0D5PE16EU)$/.test(deviceType || '');
}

/**
 * Determines whether a Pro RGBWW PM channel is a "related" (secondary) channel
 * whose output state, brightness and power consumption are controlled by the
 * main channel and therefore intentionally not selectable as scene conditions.
 *
 * For the `light`/`cctx2` profiles only the main channel (0) exposes these
 * props; for `rgbx2light` every channel except the last one does.
 *
 * @see https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2999#note_473023
 */
export function isRgbwwPmRelatedChannel(
	deviceType: string,
	rgbwwProfile: string | undefined,
	channel: number | string | undefined,
): boolean {
	if (!isRgbwwPm(deviceType)) return false;
	const ch = +(channel ?? 0);
	return (
		(['light', 'cctx2'].includes(rgbwwProfile ?? '') && ch > 0) ||
		(rgbwwProfile === 'rgbx2light' && ch > 1)
	);
}

export function is1LWithMultipleInputs(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(S3SW-0A1X1EUL|S4SW-0A1X1EUL|S3SW-0A1X5US)$/.test(deviceType || '');
}

export const categoriesWithoutEventLogDrawerTab = ['power_meter', 'gateway', 'pv'];

export const categoriesWithoutNotificationsDrawerTab = ['gateway', 'pv'];

export function batLevelGenOneExtPwrDev(devType, status, settings) {
	//if device is powered by external source then return `false` (the battery should be ignored), else return battery value
	let value;
	switch (devType) {
		case 'SHMOS-01':
		case 'SHMOS-02':
		case 'SHTRV-01':
			value = status?.charger ? false : status?.bat?.value;
			break;
		case 'SHHT-1':
			value = settings?.external_power ? false : status?.bat?.value;
			break;

		default:
			value = status?.bat?.value ? status?.bat?.value : false;
			break;
	}

	return value;
}

export function deviceListContains(types: string[] = []) {
	return Object.values(get(devices)).filter((d: Device) => types.includes(d.type)).length > 0;
}

// Form ID of 'module' devices (X Module and Module XT1)
// jti is different with every module configuration
// and that means it is a different device
export function moduleTransformId(deviceId: string, jti?: string) {
	if (deviceId.startsWith('XM')) {
		console.log('[moduleTransformId] XM Detected, returning deviceId', deviceId);
		return deviceId;
	}

	let id = 'XM' + hex_to_decimal(deviceId.toString());
	if (typeof jti !== 'undefined') {
		id = id + 'V' + jti.toUpperCase();
	}
	return id;
}

export const hasTilt = (device) => {
	//this function must support all gen 2++ devices which have tilt
	const component = get_gen_2_component_channel_structure(device);
	const settings = devices_settings.getByRealId(device.id);
	return typeof settings?.[component]?.slat !== 'undefined';
};

/**
 * Get device with its channels if there are any
 * @param device
 * @returns array with device id + channels id
 */
export const getDevicesWithItsChannels = (device) => {
	const deviceRealId = real_id(device.id);
	const devicesWithChannels = [deviceRealId];

	// Check if the device has channels and add them to the list
	for (let index = 1; index < (device.channels_count || 0); index++) {
		devicesWithChannels.push(`${deviceRealId}_${index}`);
	}

	return devicesWithChannels;
};

/**
 * Delete device from group after mode change
 * @param id device id
 */
export const deleteDeviceFromGroupOnModeChange = async (device) => {
	let updatedGroup = {};

	const devicesIdsToDelete = getDevicesWithItsChannels(device);

	for (let group of Object.values(get(groups))) {
		if (devicesIdsToDelete.some((id) => group.devices.includes(id))) {
			const updatedIds = group.devices.filter((id) => !devicesIdsToDelete.includes(id));

			updatedGroup = {
				...group,
				devices: updatedIds,
			};
			await requestSaveGroup(updatedGroup, updatedGroup.id);
		}
	}
};

export const macFromId = (id: string) => {
	//this is used inside deviceInfo and helpers.ts for device settings
	return decimal_to_hex(real_id(id).match(/\d+/)?.[0])?.toUpperCase();
};

export const getBluetoothMacFromId = (id: string) => {
	return macFromId(id)
		.toLowerCase()
		.match(/.{1,2}/g)
		.join(':');
};

export const macToID = (macAddr: string) => {
	if (!macAddr) return '';
	const hexString = macAddr.replace(/:/g, '');
	return `XB${BigInt(`0x${hexString}`)}`;
};

/**
 * Returns the device's BLE controller address (a.k.a. BD_ADDR) as a
 * lowercase 12-char hex string without separators — the exact format the
 * native iOS/Android Bluetooth bridge expects on
 * `shelly://control_bluetooth_device/?deviceID=…` URLs.
 *
 * Why this differs from `device.mac` / `device.id`:
 *  - On Gen 2+ Wi-Fi Shelly devices the chip's primary MAC (what
 *    `Shelly.GetDeviceInfo.mac` reports and what `device.id` is derived
 *    from) is the Wi-Fi STA address. The BLE radio on the same ESP32
 *    chip advertises with that address **+ 2** (a standard ESP32
 *    convention) — this is the value the device's own embedded web UI
 *    shows in its Bluetooth settings page, and the value the OS sees
 *    when scanning for the device over Bluetooth.
 *  - GBLE / BLU devices are Bluetooth-only, so `device.mac` / `device.id`
 *    already carries the actual BLE address — no offset is applied.
 *
 * Returns `''` when no usable primary MAC can be resolved.
 */
export const getBleMacFromDevice = (
	device: { id?: string; mac?: string; gen?: string } | null | undefined,
): string => {
	if (!device) return '';

	let primaryMac = '';
	if (device.mac) {
		primaryMac = device.mac.replace(/:/g, '').toLowerCase();
	} else if (device.id && /^[0-9a-f]{12}$/i.test(device.id)) {
		/** Raw MAC stored as id (GBLE convention, or some Gen 4 devices). */
		primaryMac = device.id.toLowerCase();
	} else if (device.id) {
		/** XB{decimal} canonical form — derive the hex MAC. */
		primaryMac = (macFromId(device.id) || '').toLowerCase();
	}

	if (!/^[0-9a-f]{12}$/.test(primaryMac)) return '';

	/** GBLE devices already advertise on their stored MAC — no offset. */
	if (is_GBLE(device)) return primaryMac;

	/**
	 * `BigInt(2)` rather than the `2n` literal: the build target is ES2015
	 * + a few overrides, and BigInt *literals* aren't part of that
	 * downlevel set even though the `BigInt(...)` constructor is (mirrors
	 * the existing `macToID` above).
	 */
	return (BigInt(`0x${primaryMac}`) + BigInt(2)).toString(16).padStart(12, '0');
};

/**
 * Function to get the hostname of a device
 * @param id - Device id
 * @returns - Device hostname: if device is shared, it will have custom hostname;
 * otherwise, the default one for the user is returned
 */
export const getDeviceHost = (id: string) => {
	try {
		const _device = getDevice(id);
		const defaultHostname = new URL(user_data.getUserApiUrl())?.hostname;

		if (!defaultHostname) {
			throw new Error('Default hostname not found');
		}

		if (typeof _device === 'undefined') {
			throw new Error('Device not found');
		}

		return _device?.server || defaultHostname;
	} catch (error) {
		console.error('Error getting device host:', error);
		return;
	}
};

function getDevice(id: string) {
	try {
		const allDevices = get(devices);
		let deviceId = id;
		if (!allDevices[deviceId]) {
			deviceId = real_id(id); //check if device exists in devices list. For shared devices, we can't check the real id especially if the device has shared only one channel
		}
		const _device = allDevices[deviceId];
		if (typeof _device === 'undefined') {
			throw new Error('Device not found');
		}
		return _device;
	} catch (error) {
		console.error('Error getting device:', error);
	}
}

export const defaultTempFavPositions = (unit: string) => {
	return [
		{
			mode: 'eco',
			value: unit === 'C' ? 19 : 66,
			active: false,
		},
		{
			mode: 'sleep',
			value: unit === 'C' ? 20 : 68,
			active: false,
		},
		{
			mode: 'comfort',
			value: unit === 'C' ? 22 : 72,
			active: false,
		},
		{
			mode: 'boost',
			value: unit === 'C' ? 30 : 86,
			active: false,
		},
	];
};
